import { Controller } from 'react-hook-form';
import Select from 'react-select';
import { Form } from 'react-bootstrap';

// custom form selection input used for making dynamically forms

// TODO: To refactor the styles using modules.css - developer: Edied Isaías Ramos Hernández

export const SelectFormControl = ({
  ariaLabel = 'Select form action',
  name,
  control,
  defaultValue = '',
  options = [],
  placeholder = '',
  nameOptionValue = '',
  rules = {},
  error,
  renderOptionLabel = () => {},
  selectProps = {},
  selectStyles = {}
}) => (
  <>
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      as={
        <Select
          options={options}
          aria-label={ariaLabel}
          styles={{
            ...selectCommonStyles,
            ...selectStyles
          }}
          getOptionValue={(option) => option[nameOptionValue]}
          getOptionLabel={renderOptionLabel}
          placeholder={placeholder}
          {...selectProps}
        />
      }
    />
    {error && (
      <>
        <Form.Control style={{ display: 'none' }} isInvalid={!!error} />
        <Form.Control.Feedback type="invalid">{error?.message}</Form.Control.Feedback>
      </>
    )}
  </>
);

const selectCommonStyles = {
  option: (styles) => ({ ...styles, color: 'black' }),
  control: (styles, { isSelected }) => ({
    ...styles,
    backgroundColor: isSelected ? '#eee' : 'white',
    border: 'none',
    borderBottom: '1px solid #fff'
  }),
  singleValue: (styles) => ({ ...styles, color: '#fff' })
};